import request from '@/utils/request'

export function uploadElecnotes(data) {
  return request.post('/elecnotes/upload', data)
}

export function deleteFile(data) {
  return request.post('/elecnotes/delete', data)
}

export function getLastBatch(data) {
  return request.post('/elecnotes/last-batch', data)
}

export function getElecnotesDetail(data) {
  return request.post('/elecnotes/detail', data)
}

export function getAiElecnotesDetail(data) {
  return request.post('/elecnotes/ai-detail', data)
}


export function getElecnotesList(data) {
  return request.post('/elecnotes/list', data)
}



// WEBPACK FOOTER //
// ./src/api/elecnotes.js